import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getReportingMangerList = (token) => {
  //   let qs = buildQuery(query);
  return axios.get(`${baseUrl}/employeeRole?role=Manager`, {
    headers: {
      authorization: token,
    },
  });
};

export const getEmployees = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/employees${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const getEmployeeList = (token) => {
  return axios.get(`${baseUrl}/employee-list`, {
    headers: {
      authorization: token,
    },
  });
};
export const getSalesRepList = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/getSalesRepList${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const getEmployeesList = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/employees${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const createEmployee = (data, token) =>
  axios.post(`${baseUrl}/employee`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteEmployee = (id, token) =>
  axios.delete(`${baseUrl}/employee/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateEmployee = (id, data, token) =>
  axios.patch(`${baseUrl}/employee/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getEmployeeById = (id, token) =>
  axios.get(`${baseUrl}/employee/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const getExportToExcel = (id, query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/timesheet/${id}${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const getEmployeePersonalDetailById = (id, token) =>
  axios.get(`${baseUrl}/getPersonalDetails/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getEmployeeDocumentsById = (id, token, query) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/getEmployeeDocuments/${id}${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
export const getPdfViewer = (id, token) => {
  let url = `${baseUrl}/downloadEmployeeDocument/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const postUploadJoiningDocument = (formData, token) => {
  return axios.post(`${baseUrl}/uploadJoiningdocs`, formData, {
    headers: {
      authorization: token,
    },
  });
};
export const deleteEmployeeDocument = (id, token) => {
  let url = `${baseUrl}/deleteEmployeeDocument/${id}`;
  return axios.delete(url, {
    headers: {
      authorization: token,
    },
  });
};
// export const getProjectsByUserId = (id, query, token) => {
//     let qs = buildQuery(query);
//     let url = `${baseUrl}/projects/user/${id}${qs}`;
//     return axios.get(url, {
//         headers: {
//             authorization: token
//         }
//     })
// }
